module.exports = ".ImageMediaCategoriesCon {\n  height: 100%;\n  width: 100%;\n  color: rgb(128, 127, 131);\n  overflow: hidden;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/mediacategories/mediacategories.component.css
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/mediacategories/mediacategories.component.css
// module chunks = main